<h1 mat-dialog-title>Grant Contractor Permissions <button class="close" style="float: right;" mat-button (click)="onNoClick()">X</button></h1>
<div mat-dialog-content>

  <!--
  <p>
    Would you like your selected contractor to upload retrofit documents and update information on your behalf?
    <br/>
    <small>(e.g., house photos, receipts information, permit sign-off)</small>
  </p>
  -->
  <div>
    <form [formGroup]="formPermissions" autocomplete="off">
      <mat-checkbox style="margin-left: 3px; font-size: 16px;"
        id="managePermission"
        name="managePermission"
        formControlName="managePermission"
        (change)="onCheckEventPermissions($event)">
        <!-- Under penalties of perjury, I certify that: --> 
        I agree my contractor may upload documents to my dashboard. I also acknowledge that providing my contractor with permission will enable them to view any information I upload regarding proof of residency.
      </mat-checkbox>
 
      <!-- 
      <ul style="margin-left: 9px;">
        <li>
          <a
            href="{{termsOfUseLink}}"
            target="_blank" rel="noopener"
          >{{termsOfUseLinkText}}</a>
          and
        </li>
        <li>
          <a
            href="{{programRulesLink}}"
            target="_blank" rel="noopener"
          >{{programRulesLinkText}}</a>
        </li>
      </ul>
      -->
    </form>
  </div>

</div>

<div mat-dialog-actions style="margin-top: 18px !important; float: right !important;">
  <button mat-flat-button
    color="primary"
    [disabled]="disableGrantSave"
    (click)="onClickPermissions()">
    AGREE
  </button>
</div>